<div class="user-registration" *ngIf="registrationForm && !isRegistrationDone">
  <form [formGroup]="registrationForm">
    <div class="form-container">
      <div class="left-container">
        <div class="user-details">
          <p class="title">
            {{ 'module.public.registration.headerText' | translate }}
          </p>

          <div class="note-container" *ngIf="isGemisDSO">
            <div class="icon">
              <img src="./assets/icons/information-icon.svg" class="information-img" alt="information" />
            </div>
            <div class="note">
              <span class="note-header">{{ 'module.public.registration.noteHeader' | translate }}</span>
              <span class="note-text1">{{ 'module.public.registration.noteTextLine1' | translate }}</span>
              <span class="note-text2">{{ 'module.public.registration.noteTextLine2' | translate }}</span>
            </div>
          </div>

          <p class="section-title ep-text-strong-16" *ngIf="isGemisDSO && isExternalUser">
            {{ 'module.public.registration.headerPersonalInformation' | translate }}
          </p>

          <ng-container *ngIf="!isGemisDSO || !isExternalUser">
            <div class="role-region">
              <div class="role">
                <p class="labels">
                  {{ 'module.public.registration.roleText' | translate }}
                </p>
                <p class="text">{{ role.roleName }}</p>
              </div>
              <div class="region" [ngClass]="{ 'with-region': regions.length <= 0 }">
                <p class="label">
                  {{ 'module.public.registration.regionText' | translate }}
                </p>
                <p class="label-noregion" *ngIf="regions.length <= 0">
                  {{ 'module.public.registration.noRegionText' | translate }}
                </p>
                <div class="tree-box2" [ngClass]="{ 'hide-expand-icon': !hasChildNodes }">
                  <app-list-tree
                    #tree
                    [data]="regions"
                    [itemSize]="5"
                    [searchable]="false"
                    [vScrollHeightPx]="vScrollHeightPx"
                    [fontSize]="fontSize"
                    [initialMaxItems]="3"
                    (completeEvent)="tree.toggleNodeExpansionByLevel(1)"
                  ></app-list-tree>
                </div>
              </div>
            </div>

            <mat-divider class="divider"></mat-divider>

            <p class="required-field">
              {{ 'module.public.registration.registrationInstructionText' | translate }}
            </p>
          </ng-container>

          <div class="form-groups">
            <div class="form-inline2" *ngIf="!isGemisDSO || !isExternalUser">
              <div class="form-label-email">
                <label>
                  {{ 'module.public.registration.emailFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <input class="email" type="text" disabled formControlName="email" />
                <p class="error hide">
                  {{ 'module.public.registration.separatorText' | translate }}
                </p>
              </div>
            </div>

            <div class="form-inline2">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.genderFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <mat-form-field appearance="outline" floatLabel="never" [class.selected]="isGenderDropdownOpen">
                  <mat-select
                    matNativeControl
                    disableOptionCentering
                    disableRipple
                    formControlName="gender"
                    panelClass="registration-dropdown"
                    placeholder="{{ 'module.public.registration.genderFieldTextPlaceholder' | translate }}"
                    (openedChange)="onDropdownToggle('gender')"
                  >
                    <mat-option class="option" *ngFor="let gender of genderOptions" [value]="gender.value">
                      {{ gender.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="form-inline2">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.titleFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <mat-form-field appearance="outline" floatLabel="never" [class.selected]="isTitleDropdownOpen">
                  <mat-select
                    matNativeControl
                    disableOptionCentering
                    disableRipple
                    formControlName="title"
                    panelClass="registration-dropdown"
                    placeholder="{{ 'module.public.registration.titleFieldTextPlaceholder' | translate }}"
                    (openedChange)="onDropdownToggle('title')"
                  >
                    <mat-option class="option" *ngFor="let title of userTitleOptions" [value]="title">
                      {{ title }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <p
                  [ngClass]="{
                    error: true,
                    hide: registrationForm.controls.title.valid || registrationForm.controls.title.untouched
                  }"
                >
                  {{ 'module.public.registration.validationTitleRequiredText' | translate }}
                </p>
              </div>
            </div>

            <div class="form-inline2">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.firstNameFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <input
                  [ngClass]="{ 'error-field': !(registrationForm.controls.firstName.valid || registrationForm.controls.firstName.untouched) }"
                  placeholder="{{ 'module.public.registration.firstNameFieldTextPlaceholder' | translate }}"
                  formControlName="firstName"
                  type="text"
                  required
                />
                <p
                  [ngClass]="{
                    error: true,
                    hide: registrationForm.controls.firstName.valid || registrationForm.controls.firstName.untouched
                  }"
                >
                  {{ 'module.public.registration.validationFirstNameRequiredText' | translate }}
                </p>
              </div>
            </div>

            <div class="form-inline2">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.lastNameFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <input
                  [ngClass]="{ 'error-field': !(registrationForm.controls.lastName.valid || registrationForm.controls.lastName.untouched) }"
                  placeholder="{{ 'module.public.registration.lastNameFieldTextPlaceholder' | translate }}"
                  formControlName="lastName"
                  type="text"
                  required
                />
                <p
                  [ngClass]="{
                    error: true,
                    hide: registrationForm.controls.lastName.valid || registrationForm.controls.lastName.untouched
                  }"
                >
                  {{ 'module.public.registration.validationLastNameRequiredText' | translate }}
                </p>
              </div>
            </div>

            <div class="form-inline2" *ngIf="!isGemisDSO || !isExternalUser">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.telephoneFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <input
                  [ngClass]="{ 'error-field': !(registrationForm.controls.phoneNumber.valid || registrationForm.controls.phoneNumber.untouched) }"
                  placeholder="{{ 'module.public.registration.telephoneFieldTextPlaceholder' | translate }}"
                  formControlName="phoneNumber"
                  type="text"
                  required
                  maxlength="15"
                  (input)="removeUserInputSpaces('phoneNumber')"
                />
                <p
                  [ngClass]="{
                    error: true,
                    hide: registrationForm.controls.phoneNumber.valid || registrationForm.controls.phoneNumber.untouched
                  }"
                >
                  {{ 'module.public.registration.validationTelephoneText2' | translate }}
                </p>
              </div>
            </div>

            <div class="form-inline2">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.jobFunctionFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <mat-form-field appearance="outline" floatLabel="never" [class.selected]="isJobFunctionDropdownOpen">
                  <mat-select
                    matNativeControl
                    required
                    disableOptionCentering
                    disableRipple
                    formControlName="jobFunction"
                    panelClass="registration-dropdown"
                    placeholder="{{ 'module.public.registration.jobFunctionTextPlaceholder' | translate }}"
                    (openedChange)="onDropdownToggle('jobFunction')"
                  >
                    <mat-option class="option" *ngFor="let jobFunction of jobFunctionOptions" [value]="jobFunction">
                      {{ jobFunction.jobTitle }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <p
                  [ngClass]="{
                    error: true,
                    hide: registrationForm.controls.jobFunction.valid || registrationForm.controls.jobFunction.untouched
                  }"
                >
                  {{ 'module.public.registration.validationJobFunctionRequiredText' | translate }}
                </p>
              </div>
            </div>

            <div class="form-inline2">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.jobFunctionInfoFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <input
                  placeholder="{{ 'module.public.registration.jobFunctionInfoTextPlaceholder' | translate }}"
                  formControlName="jobFunctionInfo"
                  type="text"
                  maxlength="250"
                />
              </div>
            </div>

            <div class="form-inline2">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.departmentFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <input
                  placeholder="{{ 'module.public.registration.departmentTextPlaceholder' | translate }}"
                  formControlName="department"
                  type="text"
                  maxlength="250"
                />
              </div>
            </div>

            <div *ngIf="isGemisDSO && isExternalUser">
              <p class="section-title ep-text-strong-16">
                {{ 'module.public.registration.headerDataRequest' | translate }}
              </p>

              <div class="form-inline2">
                <div class="form-label">
                  <label>
                    {{ 'module.public.registration.organisationsFormFieldText' | translate }}
                  </label>
                </div>
                <div class="form-input2">
                  <mat-form-field appearance="outline" floatLabel="never" [class.selected]="isRoleDropdownOpen">
                    <mat-select
                      matNativeControl
                      required
                      disableOptionCentering
                      disableRipple
                      formControlName="role"
                      panelClass="registration-dropdown"
                      placeholder="{{ 'module.public.registration.organisationsFormTextPlaceholder' | translate }}"
                      (openedChange)="onDropdownToggle('role')"
                      (selectionChange)="setupMunicipalityPlaceholder()"
                    >
                      <mat-option class="option" *ngFor="let role of rolesOptions" [value]="role">
                        {{ role.roleName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <p
                    [ngClass]="{
                      error: true,
                      hide: registrationForm.controls.role.valid || registrationForm.controls.role.untouched
                    }"
                  >
                    {{ 'module.public.registration.validationRoleRequiredText' | translate }}
                  </p>
                </div>
              </div>

              <div *ngIf="registrationForm.controls.role.value?.roleCode === 'MW'" class="form-field-section">
                <div class="form-input-wrapper">
                  <app-ep-form-select-dropdown
                    id="kommuneDropdownMW"
                    formControlName="municipality"
                    [options]="municipalityOptions"
                    labelKey="compositeLabel"
                    placeholder="{{ 'module.public.registration.communesTextPlaceholder' | translate }}"
                    searchPlaceholder="Suche"
                    (selectionChanged)="onMunicipalitySelectionChanged($event)"
                    [class.error-field]="isFieldInvalid('municipality')"
                  >
                  </app-ep-form-select-dropdown>
                  <mat-hint *ngIf="registrationForm.controls.municipality.untouched || registrationForm.controls.municipality.valid" class="note">
                    {{ 'module.public.registration.municipalityFieldNote' | translate }}
                  </mat-hint>
                  <p
                    *ngIf="
                      registrationForm.get('municipality')?.invalid &&
                      (registrationForm.get('municipality')?.dirty || registrationForm.get('municipality')?.touched)
                    "
                    class="form-field-error"
                  >
                    {{ 'module.public.registration.validationMunicipalityRequiredText' | translate }}
                  </p>
                </div>
              </div>

              <div *ngIf="registrationForm.controls.role.value?.roleCode === 'AAW'" class="form-field-section">
                <div class="form-field-container">
                  <div class="form-field-label">
                    <label class="ep-text-regular-16"> {{ 'module.public.registration.adminAreaRegionFieldText' | translate }}</label>
                  </div>
                  <div class="form-field-control">
                    <app-ep-form-select-dropdown
                      id="gemeindeverbandDropdownAAW"
                      formControlName="municipality"
                      [options]="municipalityOptions"
                      labelKey="compositeLabel"
                      placeholder="{{ 'module.public.registration.areaAdminRegionTextPlaceholder' | translate }}"
                      searchPlaceholder="Suche"
                      (selectionChanged)="onMunicipalitySelectionChanged($event)"
                      [class.error-field]="isFieldInvalid('municipality')"
                    >
                    </app-ep-form-select-dropdown>
                    <p
                      *ngIf="
                        registrationForm.controls.municipality.invalid &&
                        (registrationForm.controls.municipality.dirty || registrationForm.controls.municipality.touched)
                      "
                      class="form-field-error"
                    >
                      {{ 'module.public.registration.validationAdminAreaRegionRequiredText' | translate }}
                    </p>
                  </div>
                </div>

                <div
                  *ngIf="
                    registrationForm.controls.municipality.value &&
                    registrationForm.controls.municipality.valid &&
                    kommunenOptions &&
                    kommunenOptions.length > 0
                  "
                  class="form-field-container"
                >
                  <div class="form-field-label">
                    <label class="ep-text-regular-16">
                      {{ 'module.public.registration.communesFieldText' | translate }}
                    </label>
                  </div>
                  <div class="form-field-control">
                    <app-ep-form-select-dropdown
                      id="communesDropdownId"
                      formControlName="communes"
                      [options]="kommunenOptions"
                      labelKey="compositeLabel"
                      [multiSelect]="true"
                      placeholder="{{ 'module.public.registration.communesTextPlaceholder' | translate }}"
                      searchPlaceholder="Suche"
                      (selectionChanged)="onCommunesSelectionChanged($event)"
                      [class.error-field]="isFieldInvalid('communes')"
                    >
                      >
                    </app-ep-form-select-dropdown>
                    <mat-hint *ngIf="registrationForm.controls.communes.untouched || registrationForm.controls.communes.valid" class="form-field-hint note">
                      {{ 'module.public.registration.communesFieldNote' | translate }}
                    </mat-hint>
                    <p
                      *ngIf="
                        registrationForm.controls.communes.invalid && (registrationForm.controls.communes.dirty || registrationForm.controls.communes.touched)
                      "
                      class="form-field-error"
                    >
                      {{ 'module.public.registration.validationCommunesRequiredText' | translate }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="ep-text-strong-16 section-title">{{ 'module.public.registration.headerContactInformation' | translate }}</div>

              <div class="form-inline2">
                <div class="form-label">
                  <label>
                    {{ 'module.public.registration.emailFieldText' | translate }}
                  </label>
                </div>
                <div class="form-input2">
                  <input
                    [ngClass]="{
                      'error-field':
                        registrationForm.controls.email.invalid && (registrationForm.controls.email.dirty || registrationForm.controls.email.touched)
                    }"
                    placeholder="{{ 'module.public.registration.emailFieldTextPlaceholder' | translate }}"
                    formControlName="email"
                    type="email"
                  />
                  <mat-spinner *ngIf="isEmailVerifying" [diameter]="20" class="spinner" mode="indeterminate"> </mat-spinner>
                  <p
                    [ngClass]="{
                      error: true,
                      hide: registrationForm.controls.email.valid || registrationForm.controls.email.untouched
                    }"
                    *ngIf="registrationForm.get('email')?.errors"
                  >
                    {{ emailErrorMessage }}
                  </p>
                </div>
              </div>

              <div class="form-inline2">
                <div class="form-label">
                  <label>
                    {{ 'module.public.registration.telephoneFieldText' | translate }}
                  </label>
                </div>
                <div class="form-input2">
                  <input
                    [ngClass]="{ 'error-field': !(registrationForm.controls.phoneNumber.valid || registrationForm.controls.phoneNumber.untouched) }"
                    placeholder="{{ 'module.public.registration.telephoneFieldTextPlaceholder' | translate }}"
                    formControlName="phoneNumber"
                    type="text"
                    required
                    maxlength="15"
                    (input)="removeUserInputSpaces('phoneNumber')"
                  />
                  <p
                    [ngClass]="{
                      error: true,
                      hide: registrationForm.controls.phoneNumber.valid || registrationForm.controls.phoneNumber.untouched
                    }"
                  >
                    {{ 'module.public.registration.validationTelephoneText2' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <div class="form-inline2" [class.comment]="isGemisDSO && isExternalUser">
              <div class="form-label">
                <label>
                  {{ 'module.public.registration.commentFieldText' | translate }}
                </label>
              </div>
              <div class="form-input2">
                <ng-container *ngIf="isGemisDSO && isExternalUser; else inputComment">
                  <textarea
                    placeholder="{{ 'module.public.registration.commentTextPlaceholder' | translate }}"
                    formControlName="comment"
                    type="text"
                    maxlength="500"
                    rows="4"
                  >
                  </textarea>
                </ng-container>
                <ng-template #inputComment>
                  <input
                    placeholder="{{ 'module.public.registration.commentTextPlaceholder' | translate }}"
                    formControlName="comment"
                    type="text"
                    maxlength="500"
                  />
                </ng-template>
              </div>
            </div>

            <div class="form-inline2" *ngIf="idpName === 'AAD'">
              <div class="form-label">
                <label> KID </label>
              </div>
              <div class="form-input2">
                <input
                  [ngClass]="{ 'error-field': !(registrationForm.controls.kid.valid || registrationForm.controls.kid.untouched) }"
                  placeholder="{{ 'module.public.registration.kidFieldTextPlaceholder' | translate }}"
                  formControlName="kid"
                  type="text"
                  required
                  maxlength="15"
                />
                <p
                  [ngClass]="{
                    error: true,
                    hide: registrationForm.controls.kid.valid || registrationForm.controls.kid.untouched
                  }"
                >
                  KID ist erforderlich.
                </p>
              </div>
            </div>
          </div>
        </div>
        <app-kam-contact-info-v2 class="kam-info" *ngIf="municipalityId" [municipalityId]="municipalityId"></app-kam-contact-info-v2>
      </div>

      <div class="right-container">
        <div class="disclaimer-container">
          <div class="form-submit">
            <div class="mandatory-section-container">
              <div class="form-disclaimer2" *ngIf="idpName === 'CIAM'">
                <mat-checkbox class="checkbox" formControlName="acceptTerms" required> </mat-checkbox>
                <span class="disclaimer" [innerHTML]="'module.public.registration.disclaimerText' | translate"></span>
              </div>
              <div class="button-route-container" *ngIf="idpName === 'CIAM'">
                <button class="button-download" (click)="redirectToDataProtection()">
                  <app-svg-icon class="file-icon" src="./assets/icons/file-text.svg"></app-svg-icon>Datenschutzerklärung
                </button>
              </div>
              <div class="form-disclaimer3" *ngIf="!isDsoToDsoUser">
                <mat-checkbox class="checkbox" formControlName="allowConditions" required> </mat-checkbox>
                <span class="disclaimer">
                  Ich habe die allgemeinen Nutzungsbedingungen für die Nutzung des Kundenportals „EnergiePortal“ gelesen, verstanden und stimme diesen zu.
                </span>
              </div>
              <div class="button-download-container" *ngIf="!isDsoToDsoUser">
                <button class="button-download" (click)="downloadFile()">
                  <app-svg-icon class="file-icon" src="./assets/icons/file-text.svg"></app-svg-icon>Website-Richtlinie
                </button>
              </div>
            </div>
            <mat-divider *ngIf="idpName === 'CIAM'"></mat-divider>
            <div class="form-disclaimer4">
              <mat-checkbox class="checkbox" formControlName="allowNewsletter"> </mat-checkbox>
              <span class="disclaimer" [innerHTML]="'module.public.registration.newsletterText' | translate"></span>
            </div>
            <mat-divider *ngIf="idpName === 'CIAM'"></mat-divider>
            <div class="form-mt-captcha" *ngIf="isGemisDSO">
              <div class="mtcaptcha"></div>
              <input type="hidden" name="mtcaptcha-verifiedtoken" id="mtcaptcha-verifiedtoken" value="" />
            </div>
            <p id="token-debug"></p>
            <div>
              <button
                (click)="register()"
                [disabled]="!registrationForm.valid || (isGemisDSO && !captchaResolved)"
                type="submit"
                class="ep-btn ep-btn-primary registration-button-submit"
              >
                {{ 'module.public.registration.registrationSubmitButtonText' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="inquiries">
          <p class="title">
            {{ 'module.public.registration.contactText' | translate }}
          </p>
          <p class="sender">{{ sender }}</p>
          <a class="dso-email" (click)="mailer()">{{ senderEmail }}</a>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="register-success" *ngIf="isRegistrationDone">
  <app-register-success></app-register-success>
</div>

<app-overlay-loader *ngIf="isLoading"></app-overlay-loader>
